"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var background = _config.style.background,
  boxShadow = _config.style.boxShadow,
  padding = _config.style.padding;
var StyledStickyDrawer = _styledComponents["default"].div.attrs({
  className: 'fuse-sticky-drawer'
}).withConfig({
  displayName: "styled-sticky-drawer__StyledStickyDrawer",
  componentId: "sc-1ter07g-0"
})(["background:", ";bottom:0;box-shadow:", ";left:0;margin:0;padding:", ";position:fixed;right:0;width:100%;will-change:transform,visibility,height;", " @media screen and (min-width:", "){padding:", ";}@media screen and (min-width:", "){display:none;}"], background, boxShadow, padding.small, function (_ref) {
  var open = _ref.open,
    transition = _ref.transition,
    zIndex = _ref.zIndex;
  return "\n\t\ttransition: ".concat(transition, ";\n\t\ttransform: ").concat(open ? "translateY(0%)" : "translateY(100%)", ";\n\t\tvisibility: ").concat(open ? "visible" : "hidden", ";\n\t\tz-index: ").concat(zIndex, ";\n\t");
}, _grid.gridConfig.m.minWidth, padding.medium, _grid.gridConfig.l.minWidth);
var _default = exports["default"] = StyledStickyDrawer;